<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
    @media (max-width: 1270px) {
        .lg-container {
            display: none !important;
        }
    }

    @media (max-width: 880px) {
        .md-container {
            display: none !important;
        }
    }

  body {
    margin: 0px;
  }

  .re-container {
      width: 100vw;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
  }

  .relative {
      position: relative;
  }

  .absolute {
      position: absolute;
  }

  .no-overflow {
      overflow: hidden;
  }

  .flex {
      display: flex;
  }

  .flex-1 {
      flex: 1;
  }

  .flex-2 {
      flex: 2;
  }

  .column {
      flex-direction: column;
  }

  .row {
      flex-direction: row;
  }

  .vertical-center {
      align-items: center;
  }

  .center {
      text-align: center;
      justify-content: center;
  }

    .space-evenly {
        justify-content: space-evenly;
    }

  .right {
      justify-content: flex-end;
  }

  .left {
      justify-content: flex-start;
  }

  .wrap {
      width: fit-content;
  }

  .re-title {
      color: #FFFFFF;
      font-family: Trirong;
      font-size: 40px;
      font-weight: 800;
      line-height: 49px;
      margin: 15px auto;
  }

  .re-subtitle {
      color: #DAAE3E;
      font-family: Trirong;
      font-size: 12px;
      letter-spacing: 2.31px;
      line-height: 20px;
  }

  .re-text {
      color: #FFFFFF;
      font-family: Trirong;
      font-size: 16px;
      letter-spacing: 1px;
      line-height: 28px;
      margin: 10px auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue